import styled from 'styled-components';

import { c14142E, cFFFFFF } from '#/colors';

import { useAccountView } from '#/features/account/account-context';

export default function AccountBalance() {
  const accountView = useAccountView();
  return (
    <Container>
      <span>Free Collateral</span>
      <span>{accountView.freeCollateral}</span>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 500;
  color: ${cFFFFFF};
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  border-radius: 7px;
  background-color: ${c14142E};
  height: 32px;
`;
